module.exports = __webpack_public_path__ + "static/thumb-8-2a55d5d8073115e31c2dfdaf77f335d9.jpg";